import { $authHost } from "../index"

export const uploadFileAPI = async (dataForBd) => {
    let params = ''
    
    const {data} = await $authHost.post(`api/files/`, dataForBd, {
        headers: {
            // 'Content-type': 'charset=utf-8'
            'Content-type': 'multipart/form-data'
        }
    })
    return data
}